// utilities
import api from '@/utilities/api'

export const getInvoices = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/invoices',
    success (response) {
      commit('setInvoices', response.data)
    }
  })
}
export const getInvoice = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/invoices/' + payload.invoiceID,
    payload,
    success (response) {
      commit('setInvoice', response.data)
    }
  })
}
export const getInvoiceLines = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/invoices/' + payload.invoiceID + '/lines',
    payload,
    success (response) {
      commit('setInvoiceLines', response.data)
    }
  })
}
export const getInvoiceDeletedItems = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/invoices/' + payload.invoiceID + '/deleted',
    payload,
    success (response) {
      commit('setInvoiceDeletedItems', response.data)
    }
  })
}
export const getWorkingInvoice = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/invoices/working',
    payload,
    success (response) {
      commit('setWorkingInvoice', response.data[0])
    }
  })
}
export const addInvoiceAdmin = ({ commit, dispatch }, payload) => {
  // adds admin to invoice
  return api.request({
    method: 'put',
    endpoint: '/private/invoices/' + payload.invoiceID + '/admin',
    payload,
    success (response) {
      dispatch('getInvoices')
    }
  })
}
export const updateInvoice = ({ commit, dispatch }, payload) => {
  // adds source to active invoice
  return api.request({
    method: 'put',
    endpoint: '/private/invoices',
    payload,
    success (response) {
      dispatch('cart/getCart', {}, { root: true })
    }
  })
}
export const getInvoicePayments = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/invoices/' + payload.invoiceID + '/payments',
    success (response) {
      commit('setPayments', response.data)
    }
  })
}
export const getInvoiceAccountEntries = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/invoices/' + payload.invoiceID + '/accountEntries',
    success (response) {
      commit('setInvoiceAccountEntries', response.data)
    }
  })
}
export const createPayment = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'post',
    endpoint: 'private/payments',
    payload,
    success (response) {
    }
  })
}
export const deletePayment = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/payments/' + payload.paymentID,
    payload,
    success (response) {
    }
  })
}
export const finalizeInvoice = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'post',
    endpoint: 'private/invoices/finalize',
    success (response) {
      dispatch('person/getBaxterBucks', {}, { root: true })
    }
  })
}
export const createBaxterBucksAdjustment = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'post',
    endpoint: 'private/invoices/adjustments',
    payload,
    success (response) {
      dispatch('person/getBaxterBucks', {}, { root: true })
    }
  })
}
export const createRefund = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'post',
    endpoint: 'private/invoices/refund',
    payload,
    success (response) {
      dispatch('person/getBaxterBucks', {}, { root: true })
    }
  })
}
export const clearStalePayments = ({ commit, dispatch }, payload) => {
  commit('clearStalePayments')
}
